import { Injectable } from '@angular/core';
import { Department } from '@app/models/company/department.model';
import { JournalEntryReportPayPeriodFilterOption } from '@app/models/payroll/journal-entry-report-pay-period-filter-option.model';
import { JournalEntryReportItemTemplate } from '@app/models/payroll/journal-entry-reports-settings-line-item.model';
import { FileHelperService } from '@app/services';
import { JournalEntryAdditionalReportFields } from '../interfaces/additional-report-fields.interface';
import { Report } from './queries/report';

@Injectable()
export class JournalEntryReportService {
    additionalReportFields: JournalEntryAdditionalReportFields = {
        chequeDate: null,
        lastExportedAt: null,
        payPeriodEndDate: null,
        paySchedule: null,
        journalEntryReportId: null,
        totalCredit: null,
        totalDebit: null,
    };

    constructor(private fileService: FileHelperService) {}

    async fetchJournalEntryReportLineItemsTemplates(): Promise<JournalEntryReportItemTemplate[]> {
        const [journalEntryReportSettingsLineItems] = await JournalEntryReportItemTemplate.get();
        return journalEntryReportSettingsLineItems;
    }

    async fetchJournalEntryReportPayPeriodOptions(year): Promise<JournalEntryReportPayPeriodFilterOption[]> {
        const [journalEntryReportPayPeriodOptions] = await JournalEntryReportPayPeriodFilterOption.where(
            'year',
            year
        ).get();
        return journalEntryReportPayPeriodOptions;
    }

    async fetchJournalEntryReports(): Promise<Report<JournalEntryAdditionalReportFields>> {
        const journalEntryReport = await new Report<JournalEntryAdditionalReportFields>(this.fileService)
            .name('journalEntryReport')
            .page(null)
            .withAdditionalReportFields(this.additionalReportFields)
            .get();
        return journalEntryReport;
    }

    async saveJournalEntryReportItemTemplate(reportItemTemplateChange: JournalEntryReportItemTemplate): Promise<void> {
        await reportItemTemplateChange.save();
    }

    async saveDepartment(department: Department, companyId: number): Promise<void> {
        await department.param('company', companyId).save();
    }
}
